import { useEffect, useState, useRef } from "react";
import styled from "@emotion/styled";
import { TimelineTableBodyContainer } from "../Common";


const TimelineContainer = ({ children, startHour = 0 }) => {
  const [tlTop, setTlTop] = useState(0);

  const tableBodyRef = useRef(null);

  useEffect(() => {
    if (tableBodyRef?.current) {
      const rect = tableBodyRef.current.getBoundingClientRect();
      setTlTop(rect.top);
    }
  });

  // useEffect(() => { removed for now
  //   if (!startHour || startHour === 0) return
  //   tableBodyRef.current.scrollTo(0, 0)
  //   tableBodyRef.current.scrollBy({
  //     top: startHour,
  //     left: 0,
  //     behavior: 'smooth'
  //   })
  //   // console.log(document.getElementById('timeline1').getBoundingClientRect().width)
  // }, [])
  
  return (
    <TimelineTableBodyContainer ref={tableBodyRef} $top={tlTop}>
      {children}
    </TimelineTableBodyContainer>
  );
};

export default TimelineContainer;